
import React from 'react';
import { Hammer, Building, Shield, Recycle, CheckCircle } from 'lucide-react';

const DemolitionServices = () => {
  const services = [
    {
      icon: Building,
      title: "Démolition totale",
      description: "Destruction complète de bâtiments avec récupération maximale des matériaux",
      features: ["Étude préalable", "Sécurisation du site", "Évacuation des gravats"]
    },
    {
      icon: Hammer,
      title: "Démolition partielle", 
      description: "Interventions ciblées pour rénovation et aménagement d'espaces",
      features: ["Ouverture de murs", "Création d'ouvertures", "Préservation structures"]
    },
    {
      icon: Recycle,
      title: "Déconstruction sélective",
      description: "Démontage méthodique pour valorisation maximale des matériaux",
      features: ["Tri des matériaux", "Valorisation", "Traçabilité complète"]
    },
    {
      icon: Shield,
      title: "Désamiantage",
      description: "Retrait sécurisé des matériaux amiantés par des équipes certifiées",
      features: ["Équipes certifiées", "Procédures sécurisées", "Évacuation réglementaire"]
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-heading font-bold mb-4 text-fabre-gray">
            Nos Services de Démolition
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Solutions professionnelles adaptées à tous vos projets de démolition
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-fabre-green/30"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-gradient-to-br from-fabre-green to-fabre-teal rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <service.icon className="w-8 h-8 text-white" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-fabre-gray mb-3 group-hover:text-fabre-green transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-500">
                        <CheckCircle className="w-4 h-4 text-fabre-green mr-2 flex-shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DemolitionServices;
